import React from "react";
import { VipList } from "../vipList";
import { TbPokerChip } from "react-icons/tb";
import LazyImage from "../../../components/Loading/lazyImage";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../utils/formatNumber";
import { AiFillDollarCircle, AiFillGift } from "react-icons/ai";
import { FaBirthdayCake } from "react-icons/fa";
import { vipPromotion } from "../helper/detailList";

const MainCard = ({ nowLevel, nowWash }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const vipList = useSelector((state) => state.isVipDetail);

  return (
    <section
      className={`rounded-[5px] flex flex-col items-center justify-center py-[15px] bg-gradient-to-br ${vipList[nowLevel]?.background}`}
    >
      <div className="w-[132px] h-[132px] mb-[12px]">
        <LazyImage
          className="!w-[132px] !h-[132px] object-scale-down"
          src={vipList[nowLevel]?.icon}
          loadingClassName={`!rounded-full`}
        />
      </div>
      {/* <p className="text-light-white text-3xl font-medium tracking-tight mb-[12px]">
        {i18n(vipList[nowLevel]?.label?.toLowerCase())}
      </p> */}
      <p className="text-light-white">
        {formatNumber(nowWash, { point: false })} /{" "}
        {formatNumber(vipList[nowLevel + 1]?.wash_max, { point: false })}{" "}
        {i18n("until")} {i18n(vipList[nowLevel + 1]?.label?.toLowerCase())}
      </p>
      <section className="flex flex-col gap-[10px]">
        {vipPromotion.map((item) => {
          return !vipList[nowLevel]?.[item.label] ||
            vipList[nowLevel]?.[item.label] == 0 ? null : (
            <div className="flex items-center justify-between gap-[5px] px-[10px] p-[2px] rounded-full font-medium bg-[#0B0D0E]">
              <div className="flex items-center gap-[5px] text-[#3FAD66]">
                {item.icon}
                <span className="text-light-white tracking-tighter text-sm">
                  {i18n(item.label)}：
                </span>
              </div>
              <span className="text-light-white tracking-tighter">
                {vipList?.[nowLevel]?.[item.label]}
                {i18n(item.symbol)}
              </span>
            </div>
          );
        })}
      </section>
    </section>
  );
};

export default MainCard;
